import React, { useRef } from 'react';
import { withAreaGetter } from '../../providers/AreasConsumers';
import menuConfig from 'constants/menuConfig';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Portal from '../../utils/portal/Portal';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { areas } from '../../constants/areas';
import { useHeader } from 'providers/AreasProvider';
import { useTitle } from 'utils/hooks/useTitle';
import { Typography } from '@totalsoft/rocket-ui';

const HeaderPortal = ({ t, location, getElemByAreaKey, children }) => {
  const [header] = useHeader();
  const headerRef = useRef();

  const getPageTitle = () => {
    const pathName = makeBrand(location.pathname);
    return pathName ? t('NavBar.' + pathName) : header && header.props.children;
  };

  const makeBrand = pathname => {
    var name;
    menuConfig.map(menu => {
      if (menu.path === pathname) {
        name = menu.name;
      }
      return null;
    });
    if (pathname === '/user') {
      name = 'User';
    }
    if (pathname === '/folders') {
      name = 'Folders';
    }
    if (pathname?.startsWith('/simulator')) {
      name = 'Simulator';
    }
    if (pathname === '/partner-files') {
      name = 'PartnerFiles';
    }

    return name || '';
  };

  useTitle(getPageTitle());

  return (
    <Portal container={getElemByAreaKey(areas.header)}>
      <Typography variant='subtitle1' fontWeight='bold' whiteSpace='nowrap'>
        {getPageTitle()}
      </Typography>
      <div ref={headerRef}>{children}</div>
    </Portal>
  );
};

HeaderPortal.propTypes = {
  t: PropTypes.func.isRequired,
  getElemByAreaKey: PropTypes.func.isRequired,
  children: PropTypes.object,
  location: PropTypes.object.isRequired
};

export default compose(withAreaGetter, withRouter, withTranslation())(HeaderPortal);
